import Typography from "@/components/foundation/typography"
import Icons from "@/components/Icon"
import Wysiwyg from "@/components/Wysiwyg"
import classNames from "classnames"
import _ from "lodash"
import React from "react"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import style from "./style.scss"

interface MissionModalProps {
  instructions: boolean
  closeModal: () => void
  modalOpen: boolean
  title?: string
  body: string
}

const defaultProps = {
  title: "Instructions"
}

const MissionModal: React.SFC<Readonly<MissionModalProps>> = (props) => {
  return (
    <aside
      className={classNames(style.modal, {
        [style["modal--open"]]: props.instructions && props.modalOpen
      })}
    >
      <div className={style.header}>
        <Typography.P1 as="h1" className={style.title}>
          {props.title || defaultProps.title}
        </Typography.P1>

        <button
          className={style.close}
          type="button"
          onClick={props.closeModal}
        >
          <Icons.Cross />
        </button>
      </div>

      <Wysiwyg className={style.body} content={props.body} />
    </aside>
  )
}

export default MissionModal
